module.exports = __webpack_public_path__ + "static/media/logo-generalitat.799f73a3.png";